import {
  Heading,
  Textarea,
  Input,
  Flex,
  Box,
  Checkbox,
  RadioGroup,
  Radio,
  Spacer,
  Divider,
  Button,
  Grid,
  FormControl,
  FormLabel,
  Text,
  Image,
  useBreakpointValue,
} from "@chakra-ui/react";
import { useTheme } from "@emotion/react";
import { useContext, useEffect, useRef, useState } from "react";
import { imageToBase64 } from "utils/functions/function";
import Select from "react-select";
import { AppContext } from "AppProvider/AppContext";

type FormLayoutProps = {
  elements: any;
  designElement: any;
  type?: any;
};
const FormLayout = ({ elements, designElement, type }: FormLayoutProps) => {
  const [formData, setFormData] = useState<any>({});
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { toastNotify } = useContext(AppContext);
  const theme = useTheme();
  console.log("des", designElement);
  console.log("ele", elements);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // form submission logic
    console.log(formData);
  };
  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectChange = (value: any, fieldName: string) => {
    setFormData((prev: any) => ({ ...prev, [fieldName]: value }));
  };

  const handleFileChange = (
    e: any,
    name: string,
    maxFiles: number,
    minFiles: number,
    maxFileSizeKB: number,
    minFileSizeKB: number
  ) => {
    const files = e.target.files;

    if (files && files.length > 0) {
      const maxFileSize = maxFileSizeKB * 1024; // 1 KB = 1024 bytes
      const minFileSize = minFileSizeKB * 1024; // 1 KB = 1024 bytes

      // Check file number and file size in the same if condition
      const filesValid = Array.from(files).every((file: any) => {
        const isSizeValid =
          file.size >= minFileSize && file.size <= maxFileSize;
        return isSizeValid;
      });

      if (
        maxFiles &&
        files.length <= maxFiles &&
        minFiles &&
        files.length >= minFiles &&
        filesValid
      ) {
        const filePromises = Array.from(files).map((file: any) =>
          imageToBase64(file).then((base64String) => ({
            name: file.name,
            file: base64String,
          }))
        );

        Promise.all(filePromises)
          .then((base64Files) => {
            setFormData({
              ...formData,
              [name]: base64Files,
            });
          })
          .catch((error) => {
            console.error("Error converting images to base64:", error);
          });
      } else {
        // Separate alerts for each condition
        if (maxFiles && files.length > maxFiles) {
          toastNotify({
            title: `You can only upload up to ${maxFiles} files.`,
            message: "Something went wrong.",
            type: "error",
          });
        } else if (minFiles && files.length < minFiles) {
          toastNotify({
            title: `You must upload at least ${minFiles} files.`,
            message: "Something went wrong.",
            type: "error",
          });
        } else {
          for (const file of files) {
            if (file.size > maxFileSize) {
              toastNotify({
                title: `File ${file.name} exceeds the maximum size of ${maxFileSizeKB} KB.`,
                message: "Something went wrong.",
                type: "error",
              });
              break;
            }
            if (file.size < minFileSize) {
              toastNotify({
                title: `File ${file.name} is smaller than the minimum size of ${minFileSizeKB} KB.`,
                message: "Something went wrong.",
                type: "error",
              });
              break;
            }
          }
        }
      }
    }
  };

  const handleCheckboxChange = (fieldName: any, label: any, isChecked: any) => {
    setFormData((prevFormData: any) => {
      const updatedFieldData = {
        ...prevFormData[fieldName],
        [label]: isChecked,
      };

      return {
        ...prevFormData,
        [fieldName]: updatedFieldData,
      };
    });

    console.log(formData);
  };

  const handleRadioChange = (name: string, value: string) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Set default values in the state
  useEffect(() => {
    const defaultValues: { [key: string]: string | boolean } = {};
    elements.forEach((field: any) => {
      if (field.value !== undefined) {
        defaultValues[field.name] = field.value;
      }
    });
    setFormData(defaultValues);
  }, [elements]);

  const renderElement = (item: any, type: any) => {
    const commonProps = {
      id: item.name,
      name: item.name,
      placeholder: item.placeholder,
      isRequired: item.required,
      value: formData[item.name] || "",
      onChange: handleChange,
      maxLength: item.maxLength,
    };

    console.log("render items are", item);

    switch (type) {
      case "heading":
        const sizes: any = { h1: "xl", h2: "lg", h3: "md", h4: "sm", h5: "xs" };
        return (
          <Heading
            size={item?.subType ? sizes[item?.subType] : "12px"}
            style={
              Object.keys(item?.style || {}).length > 0
                ? dynamicStyles(item?.style?.component)
                : dynamicStyles(designElement?.heading)
            }
          >
            {item?.label}
          </Heading>
        );
      case "paragraph":
        return item.subtype === "p" ? (
          <p>{item.label}</p>
        ) : item.subtype === "blockquote" ? (
          <blockquote dangerouslySetInnerHTML={{ __html: item?.label }} />
        ) : item?.subtype === "address" ? (
          <address dangerouslySetInnerHTML={{ __html: item.label }} />
        ) : (
          <p>{item.label}</p>
        );
      case "textarea":
        return (
          <Textarea
            {...commonProps}
            rows={item.rows}
            style={dynamicStyles(item?.style?.component)}
          />
        );
      case "text":
        return (
          <Input
            type={item.subType}
            {...commonProps}
            minLength={item.min}
            maxLength={item.max}
            isRequired={item?.required}
            disabled={item?.disabled}
            isReadOnly={item?.readOnly}
            style={dynamicStyles(item?.style?.component)}
          />
        );
      case "email":
        return (
          <Input
            type={item.subType}
            {...commonProps}
            minLength={item?.min}
            maxLength={item?.max}
            isRequired={item?.required}
            disabled={item?.disabled}
            isReadOnly={item?.readOnly}
            style={dynamicStyles(item?.style?.component)}
          />
        );
      case "number":
        return (
          <Input
            {...commonProps}
            type={item?.subType}
            step={item.step}
            minLength={item?.min}
            maxLength={item?.max}
            isRequired={item?.required}
            disabled={item?.disabled}
            isReadOnly={item?.readOnly}
            style={dynamicStyles(item?.style?.component)}
          />
        );
      case "date":
        return (
          <Flex>
            <Input
              {...commonProps}
              type={item?.subType}
              min={item.min}
              max={item.max}
              step={item.step}
              isRequired={item?.required}
              disabled={item?.disabled}
              isReadOnly={item?.readOnly}
              style={dynamicStyles(item?.style?.component)}
            />
          </Flex>
        );
      case "select":
        return (
          <Box style={item?.style}>
            <Select
              id={item.name}
              name={item.name}
              isMulti={item?.allowMultiple}
              options={item?.option}
              placeholder={item.placeholder}
              value={formData[item.name]}
              onChange={(e) => {
                handleSelectChange(e, item.name);
              }}
              // styles={customStyle}
              styles={dynamicStyles(item?.style?.component)}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "#38B2AC",
                  primary25: "#B2F5EA",
                  primary50: "#B2F5EA",
                },
              })}
              required={item?.required}
            />
          </Box>
        );
      case "file":
        return (
          <Input
            name={item.name}
            type="file"
            ref={fileInputRef}
            className="chooseFile"
            multiple={item?.allowMultiple}
            onChange={(e) =>
              handleFileChange(
                e,
                item.name,
                item.maxFiles,
                item.minFiles,
                item.maxSize,
                item.minSize
              )
            }
            isRequired={item?.required}
            isDisabled={item?.disabled}
            style={dynamicStyles(item?.style?.component)}
          />
        );
      case "checkbox":
        return (
          <Box
            display={item.inline ? "flex" : "grid"}
            gap={4}
            alignItems="center"
            // style={dynamicStyles(item?.style?.component)}
          >
            {item.option?.map((value: any) => (
              <Checkbox
                key={value.label}
                id={value.label}
                style={dynamicStyles(item?.style?.component)}
                name={value.label}
                onChange={(e) =>
                  handleCheckboxChange(item.name, value.label, e.target.checked)
                }
                checked={
                  Object.keys(formData).length > 0 &&
                  formData[item.name] &&
                  typeof formData[item.name] === "object" &&
                  formData[item.name][value.label]
                    ? formData[item.name][value.label]
                    : false
                }
                isRequired={item?.required}
                disabled={item?.disabled}
                multiple={item?.allowMultiple}
              >
                {value.label}
              </Checkbox>
            ))}
          </Box>
        );
      case "radio":
        return (
          <RadioGroup
            name={item.name}
            onChange={(value: any) => handleRadioChange(item.name, value)}
            value={formData[item.name] || ""}
            // colorScheme="teal"
            style={dynamicStyles(item?.style?.component)}
          >
            <Box
              display={item.inline ? "flex" : "grid"}
              gap={4}
              alignItems="center"
            >
              {item.option?.map((option: any) => (
                <Radio key={option.value} value={option.value}>
                  {option.label}
                </Radio>
              ))}
            </Box>
          </RadioGroup>
        );
      case "spacer":
        return <Spacer />;
      case "divider":
        return <Divider />;
      case "button":
        return (
          <Flex justify={"end"} align={"end"} h={"100%"}>
            <Button
              name={item.name}
              type={item.subType}
              className={item.className}
              onClick={
                item?.subType === "reset" ? () => setFormData({}) : undefined
              }
              style={dynamicStyles(item?.style?.component)}
            >
              {item.label}
            </Button>
          </Flex>
        );
      case "logo":
        return (
          <Box
            boxSize={item?.boxSize}
            style={dynamicStyles(item?.style?.component)}
          >
            <Image src={item?.logo[0]?.file} alt="logo" />
          </Box>
        );
      default:
        return (
          <>
            {/* <FormLabel>{item?.name}</FormLabel> */}
            <Input
              {...item}
              borderWidth="1px"
              borderColor="gray.400"
              focusBorderColor="blue.500"
              placeholder={item?.placeholder || "Enter text"}
              style={dynamicStyles(item?.style?.component)}
            />
          </>
        );
    }
  };

  const renderElementBasedOnType = (item: any) => {
    const typesToCheck = [
      "heading",
      "divider",
      "button",
      "paragraph",
      "spacer",
      "logo",
    ];

    if (typesToCheck.includes(item.type)) {
      return renderElement(item.attributes, item.type);
    }

    return null;
  };

  const dynamicStyles = (element: any) => {
    const styles: any = {
      backgroundColor: element?.bgColor,
      borderStyle: element?.borderStyle,
      borderWidth: element?.borderWidth,
      borderColor: element?.borderColor,
      margin: element?.margin,
      padding: element?.padding,
      color: element?.fontColor,
      fontSize: element?.fontSize,
      fontWeight: element?.fontWeight,
      textTransform: element?.textTransform,
      textDecoration: element?.textDecoration,
    };

    return Object.keys(styles)
      .filter((key) => styles[key] !== undefined)
      .reduce((acc: any, key: string) => {
        acc[key] = styles[key];
        return acc;
      }, {});
  };

  const templateColumns = useBreakpointValue({
    base: "1fr",
    lg: "repeat(8, 1fr)",
  });

  const getTemplateColumns = () => {
    if (type === "mobile" || type === "tab") {
      return "1fr";
    } else if (type === "desktop" || !type) {
      return templateColumns;
    }
  };

  const getGridColumn = (item: any) => {
    if (type === "mobile" || type === "tab") {
      return "1 / -1";
    } else if (type === "desktop" || !type) {
      return {
        base: "1 / -1",
        lg: `${item.x + 1} / span ${item.w}`,
      };
    }
  };

  const getGridRow = (item: any) => {
    if (type === "mobile" || type === "tab") {
      return "auto";
    } else if (type === "desktop" || !type) {
      return {
        base: "auto",
        lg: item.y !== undefined ? `${item.y + 1} / span ${item.h}` : "auto",
      };
    }
  };

  return (
    <Box id="global" style={dynamicStyles(designElement?.global)}>
      <form
        onSubmit={handleSubmit}
        id="form"
        style={dynamicStyles(designElement?.form)}
      >
        <Grid templateColumns={getTemplateColumns()} gap={4}>
          {elements.map((item: any) => {
            let style =
              typeof item?.attributes?.style === "object"
                ? item?.attributes?.style
                : {};

            return (
              <Box
                key={item.id}
                gridColumn={getGridColumn(item)}
                gridRow={getGridRow(item)}
                style={{
                  ...dynamicStyles(designElement?.formGroup),
                  // ...dynamicStyles(style?.formControl),
                }}
              >
                {item.type !== "heading" &&
                  item.type !== "divider" &&
                  item?.type !== "button" &&
                  item?.type !== "paragraph" &&
                  item?.type !== "spacer" &&
                  item?.type !== "logo" && (
                    <FormControl
                      isInvalid={false}
                      style={{
                        ...dynamicStyles(designElement?.formControl),
                        ...dynamicStyles(style?.formControl),
                      }}
                    >
                      <FormLabel
                        style={{
                          ...dynamicStyles(designElement?.label),
                          ...dynamicStyles(style?.label),
                        }}
                      >
                        {item?.attributes?.label} &nbsp;
                        {item?.attributes?.required && (
                          <span style={{ color: "red" }}>*</span>
                        )}
                      </FormLabel>
                      {item?.attributes?.description !== "" &&
                        item?.attributes?.descriptionPlacement === "above" && (
                          <Text
                            fontSize="12px"
                            color="blue.500"
                            style={dynamicStyles(designElement?.helpText)}
                          >
                            {item?.attributes?.description}
                          </Text>
                        )}
                      {renderElement(item.attributes, item.type)}
                      {item?.attributes?.description !== "" &&
                        item?.attributes?.descriptionPlacement === "below" && (
                          <Text
                            fontSize="12px"
                            color="blue.500"
                            style={dynamicStyles(designElement?.helpText)}
                          >
                            {item?.attributes?.description}
                          </Text>
                        )}
                    </FormControl>
                  )}
                {renderElementBasedOnType(item)}
              </Box>
            );
          })}
        </Grid>
      </form>
    </Box>
  );
};

export default FormLayout;
